import { ReactNode } from "react";
import { styles } from "./FeatureItem.style";

export interface FeatureItemProps {
  icon?: ReactNode;
  title: string;
  description: string;
}

export const FeatureItem = (props: FeatureItemProps) => {
  const { icon, title, description } = props;

  return (
    <li className={styles.root()}>
      {!!icon && (
        <span className={styles.iconCircle()} aria-hidden="true">
          {icon}
        </span>
      )}
      <div className={styles.text()}>
        <p className={styles.title()}>{title}</p>
        <p className={styles.description()}>{description}</p>
      </div>
    </li>
  );
};
